import { render, staticRenderFns } from "./NavigationItemChild.vue?vue&type=template&id=4b76d8b2&"
import script from "./NavigationItemChild.vue?vue&type=script&lang=js&"
export * from "./NavigationItemChild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports